var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "google account connect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.292969,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#1F408C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.293C8 12.3304 12.0374 8.29297 17 8.29297C19.0043 8.29297 20.9013 8.9378 22.4861 10.1578L20.3946 12.8746C19.4147 12.1203 18.2409 11.7215 17 11.7215C13.9279 11.7215 11.4286 14.2209 11.4286 17.293C11.4286 20.3651 13.9279 22.8644 17 22.8644C19.4743 22.8644 21.577 21.2433 22.3016 19.0073H17V15.5787H26V17.293C26 22.2556 21.9626 26.293 17 26.293C12.0374 26.293 8 22.2556 8 17.293Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google.3de60238000ed3601fee465d3fb3bcc1.svg";